import React from 'react';
import {
  IProductPackageNode,
  IProductVersion,
  PackageNodeTypeBaseline,
  PatchPageList
} from '@/tpss/types';
export interface IProductDetailContext {
  currentProductVersion: IProductVersion; // 当前产品版本
  setCurrentProductVersion: (productVersion: IProductVersion) => void; //设置当前产品版本
  targetPackageData: IProductPackageNode; // 当前包数据, 可以是 baseline 也也已是 patch
  setTargetPackageData: (packageData: IProductPackageNode) => void; // 设置当前包数据
  selectedBaselinePackageData: IProductPackageNode; // 当前选择的 baseline,
  setSelectedBaselinePackageData: (packageData: IProductPackageNode) => void; // 设置当前包数据
  chooseBaselinePackageNode: (packageData: IProductPackageNode) => void; //选择包节点
  choosePatchPackageNode: (packageData: IProductPackageNode) => void; //选择包节点

  softwareDownloadData: any[];
  materialDownloadData: any[];
  toolDownloadData: any[];

  currentSoftwareType: string; // 当前选中的包类型，是 baseline 还是 patch
  setCurrentSoftwareType: (softwareType: string) => void; // 设置 选中的包类型
  patchPage: string; // 设置 patch 的展示页面
  setPatchPage: (patchPage: string) => void;

  currentPatchList: any[]; //当前选的 baseline 的 patch
  setCurrentPatchList: (currentPatchList: any[]) => void;

  currentBaseline: string; //当前选中的 baseline 数据
  setCurrentBaseline: (currentBaseline: string) => void;
  currentPatch: string; // 当前选中的 patch 数据
  setCurrentPatch: (currentPatch: string) => void;
}

const ProductDetailContext = React.createContext<IProductDetailContext>({
  currentProductVersion: {} as IProductVersion,
  setCurrentProductVersion: () => {},
  targetPackageData: {} as IProductPackageNode,
  setTargetPackageData: () => {},
  selectedBaselinePackageData: {} as IProductPackageNode,
  setSelectedBaselinePackageData: () => {},

  softwareDownloadData: [],
  materialDownloadData: [],
  toolDownloadData: [],

  chooseBaselinePackageNode: (packageData: IProductPackageNode) => {},
  choosePatchPackageNode: (packageData: IProductPackageNode) => {},
  currentSoftwareType: PackageNodeTypeBaseline,
  setCurrentSoftwareType: (softwareType: string) => {},
  patchPage: PatchPageList,
  setPatchPage: (patchPage: string) => {},
  currentPatchList: [],
  setCurrentPatchList: (currentPatchList: any[]) => {},
  currentBaseline: '',
  setCurrentBaseline: (currentBaseline: string) => {},
  currentPatch: '',
  setCurrentPatch: (currentPatch: string) => {}
});

export default ProductDetailContext;
